















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Settings } from "../../core/services/configService";

@Component
export default class PdfViewer extends Vue {
  @Prop({ required: true }) src!: string;

  loading: boolean = false;
  error: boolean = false;
  pageCount: number = 0;
  private renderId: number = 0;

  mounted() {
    this.renderPdf();
  }

  @Watch("src")
  onSrcChanged() {
    this.renderPdf();
  }

  async renderPdf() {
    const id = ++this.renderId;
    this.pageCount = 0;
    this.error = false;
    if (!this.src) return;
    this.loading = true;
    try {
      const pdfjs = await this.loadLib();
      const pdf = await pdfjs.getDocument(this.requestParams()).promise;
      if (id !== this.renderId) return;
      this.pageCount = pdf.numPages;
      this.loading = false;
      await this.$nextTick();
      const canvases = this.$refs.page as HTMLCanvasElement[];
      for (let i = 0; i < pdf.numPages; i++) {
        const page = await pdf.getPage(i + 1);
        if (id !== this.renderId) return;
        await this.drawPage(page, canvases[i]);
      }
    } catch (e) {
      if (id !== this.renderId) return;
      this.loading = false;
      this.error = true;
    }
  }

  private async loadLib() {
    const [pdfjs] = await Promise.all([
      import("pdfjs-dist/legacy/build/pdf"),
      import("pdfjs-dist/legacy/build/pdf.worker.entry"),
    ]);
    return pdfjs;
  }

  private requestParams(): any {
    const isApi = this.src.startsWith(Settings.HostName);
    return isApi
      ? { url: this.src, withCredentials: true, httpHeaders: { "X-Auth-Audience": "cz" } }
      : { url: this.src };
  }

  private async drawPage(page: any, canvas: HTMLCanvasElement) {
    const width = (this.$el as HTMLElement).clientWidth || page.getViewport({ scale: 1 }).width;
    const ratio = window.devicePixelRatio || 1;
    const scale = (width / page.getViewport({ scale: 1 }).width) * ratio;
    const viewport = page.getViewport({ scale });
    canvas.width = viewport.width;
    canvas.height = viewport.height;
    await page.render({ canvasContext: canvas.getContext("2d"), viewport }).promise;
  }
}
